import React, { useContext, useState } from 'react'
import { 
  Container,
  GridContainer,
  HorizontalHeader,
  VerticalHeader,
  CellInput,
  HalfInputsDiv,
  HalfCellInput
} from './style'
import ParametersContext from '../../../../../../contexts/ParametersContext'

interface StructureTableProp {
  index: number
}

const StructureTable: React.FC<StructureTableProp> = (props) => {
  const { structures, setStructures } = useContext(ParametersContext) 

  let unit = ''

  switch(structures[props.index].format){
    case 'Porcentagem':
      unit = '%'
      break;
    case 'Graus':
      unit = '°'
      break;
    case 'Nenhum':
      break;
    default:
      unit = structures[props.index].format
  }

  const handleChange = (value: string, rowIndex: number, columnIndex: number, isMin: boolean) => {
    let numericValue = value.replace(/[^0-9,]/g, '')
  
    const parts = numericValue.split(',')
    if (parts.length > 2) {
      numericValue = parts[0] + ',' + parts.slice(1).join('')
    }
  
    if (numericValue.startsWith('0') && !numericValue.startsWith('0,')) {
      numericValue = numericValue.replace(/^0+/, '0')
    }
  
    const [integerPart, decimalPart] = numericValue.split(',')
    let formattedValue = ''
  
    if (numericValue === '') {
      formattedValue = ''
    } else if (decimalPart !== undefined) {
      formattedValue = `${integerPart || '0'},${decimalPart}`
    } else {
      formattedValue = integerPart
    }
  
    if (!isNaN(Number(formattedValue.replace(',', '.')))) {
      const newStructures = [...structures]
      if (isMin) {
        newStructures[props.index].minTable[rowIndex][columnIndex] = formattedValue
      } else {
        newStructures[props.index].maxTable[rowIndex][columnIndex] = formattedValue
      }
      setStructures(newStructures)
    }
  };
  
  

  return (
      <Container>
        <GridContainer 
          rowCount={structures[props.index].tableRows.length}
          columnCount={structures[props.index].tableColumns.length}
        >
          <HorizontalHeader></HorizontalHeader>
          {structures[props.index].tableColumns.map((column) => (
            <HorizontalHeader key={column}>{column}</HorizontalHeader>
          ))}
          {structures[props.index].tableRows.map((row, rowIndex) => (
            <>
              <VerticalHeader key={row}>{row}</VerticalHeader>
              {structures[props.index].tableColumns.map((column, columnIndex) => {
                if (structures[props.index].hasMinMax){
                  return (
                    <HalfInputsDiv key={column.concat(row)}>
                      <HalfCellInput
                        type='text'
                        // feito para poder aplicar as bordas nos inputs certos, o " one" no final é para poder estilizar os primeiros e segundos separadamente
                        className={"one".concat(String(rowIndex)).concat(String(columnIndex)).concat(" one")}
                        placeholder="min"
                        value = {structures[props.index].minTable[rowIndex][columnIndex]}
                        onChange = {(e) => handleChange(e.target.value, rowIndex, columnIndex, true)}
                      /> 
                      <HalfCellInput
                        type='text'
                        className={"two".concat(String(rowIndex)).concat(String(columnIndex)).concat(" two")}
                        placeholder="max"
                        value = {structures[props.index].maxTable[rowIndex][columnIndex]}
                        onChange = {(e) => handleChange(e.target.value, rowIndex, columnIndex, false)}
                      /> 
                    </HalfInputsDiv>
                  )
                }
                return(
                  <CellInput
                      type='text'
                      className='normal'
                      disabled
                      key={column.concat(row)}
                      placeholder={unit}
                      value = ''
                  /> 
              )})}
            </>
          ))}
      </GridContainer>

        {/* <Table>
          <TableHead>
            <HorizontalHeaderRow>
              <HorizontalHeaderCell/>
              {structures[props.index].tableColumns.map((item) => (
                <HorizontalHeaderCell key={item}>{item}</HorizontalHeaderCell>
              ))}
            </HorizontalHeaderRow>
          </TableHead>
          <TableBody>
            {structures[props.index].tableRows.map((item, rowIndex) => (
              <ItemRow key={rowIndex}>
                <VerticalHeaderCell>{item}</VerticalHeaderCell>
                {structures[props.index].tableColumns.map((item, colIndex) => (
                  <ItemCell 
                    className={rowIndex !== structures[props.index].tableRows.length-1 ? 'notLast' : ''}
                    key={item}
                  > 
                    {formating[structures[props.index].format as keyof FormatConverter]}
                  </ItemCell>
                ))}
              </ItemRow>
            ))}
          </TableBody>
        </Table> */}
      </Container>
  )
}
export default StructureTable
